import { useConfig, useCurrentDoc } from 'docz';
import React from 'react';
import Scrollspy from 'react-scrollspy';
import { Container, Heading, icon, Sticky, Toc } from './custom-styles';
import { jsx as ___EmotionJSX } from "@emotion/core";

var NavHeadings = function NavHeadings() {
  var _useConfig = useConfig(),
      _useConfig$themeConfi = _useConfig.themeConfig.menu;

  _useConfig$themeConfi = _useConfig$themeConfi === void 0 ? {} : _useConfig$themeConfi;
  var _useConfig$themeConfi2 = _useConfig$themeConfi.headings;
  _useConfig$themeConfi2 = _useConfig$themeConfi2 === void 0 ? {} : _useConfig$themeConfi2;
  var _useConfig$themeConfi3 = _useConfig$themeConfi2.rightSide,
      rightSide = _useConfig$themeConfi3 === void 0 ? false : _useConfig$themeConfi3,
      _useConfig$themeConfi4 = _useConfig$themeConfi2.depth,
      depth = _useConfig$themeConfi4 === void 0 ? 3 : _useConfig$themeConfi4,
      _useConfig$themeConfi5 = _useConfig$themeConfi2.scrollspy,
      scrollspy = _useConfig$themeConfi5 === void 0 ? true : _useConfig$themeConfi5;
  var currentDoc = useCurrentDoc();
  var headings = currentDoc.headings;

  if (!rightSide) {
    return null;
  }

  var ui = headings.map(function (heading, i) {
    if (heading.depth > depth) return null;
    return ___EmotionJSX("li", {
      key: i
    }, ___EmotionJSX("a", {
      href: "#" + heading.slug,
      className: "" + (heading.depth > 2 ? 'inner' : '')
    }, heading.value));
  });
  return ___EmotionJSX(Container, null, ___EmotionJSX(Sticky, {
    className: "nav-headings"
  }, ___EmotionJSX(Toc, null, ___EmotionJSX("div", null, ___EmotionJSX(Heading, null, icon, " Contents"), scrollspy ? ___EmotionJSX(Scrollspy, {
    items: headings.map(function (heading) {
      return heading.slug;
    }),
    currentClassName: "current"
  }, ui) : ___EmotionJSX("ul", null, ui)))));
};

export default NavHeadings;

if (typeof NavHeadings !== 'undefined' && NavHeadings && NavHeadings === Object(NavHeadings) && Object.isExtensible(NavHeadings) && !Object.prototype.hasOwnProperty.call(NavHeadings, '__filemeta')) {
  Object.defineProperty(NavHeadings, '__filemeta', {
    configurable: true,
    value: {
      name: "NavHeadings",
      filename: "node_modules/@nejcm/docz-theme-extended/src/gatsby-theme-docz/components/NavHeadings/index.js"
    }
  });
}